import { Button } from '@service-victoria/component-library/components/Button';
import Notification from '@service-victoria/component-library/components/Notification';
import { url } from 'app/utils';
import * as Styled from './styled';

const AccountError: React.FC = () => {
  return (
    <Styled.Wrapper>
      <Notification.Error.Text
        title='Alert'
        value='Sorry, something went wrong while processing your request. Please try again.'
      />
      <Styled.ButtonWrapper>
        <Button
          buttonType='primary'
          onClick={() => {
            window.location.href = url.getAppBaseUrl();
          }}>
          Start over
        </Button>
      </Styled.ButtonWrapper>
    </Styled.Wrapper>
  );
};

export default AccountError;
